import styled from 'styled-components';
import { px } from '../../../../contrib/ui';

export const StyledContestSetup = styled.div`
  .paper.add-players {
    margin-bottom: ${px(25)};

    .grid-container {
      .grid-item {
        &.left {
          h3 {
            padding-top: ${px(9)};
            padding-bottom: ${px(9)};
          }
        }
        &.right {
        }
      }
    }

    .player-lookup-container {
      margin-bottom: ${px(15)};
      display: flex;
      flex-direction: row-reverse;

      div.search {
        width: 60%;
        .material-input.override {
          margin-top: 0;
        }
      }
    }

    .mobile-filters-container {
      margin-bottom: ${px(15)};
      width: 100%;

      .autocomplete.outlined {
        width: 100%;

        .hidden: {
          width: 0%;
        }
      }

      .grid-item {
        .input-form-control > .material-input.override {
          margin-top: 0;
        }

        &.icon-container {
          text-align: center;

          .expand-player-lookup {
            padding: 0;
          }
        }
      }
    }
  }
`;
